import type { Font, ThemeProps } from '@emotion/react';

type FontTypes = 's1' | 's2' | 's3' | 's4' | 's5' | 's6' | 'tiny';

type ThemeFont = {
  '@media (max-width: 640px)': Partial<Font>;
} & Font;

const mobileFontMultiplier = {
  s1: 0.75, // 60px -> 42px (typical values)
  s2: 0.75, // 42px -> 32px
  s3: 0.75, // 32px -> 24px
  s4: 0.75, // 24px -> 18px
  s5: 0.75, // 20px -> 15px
  s6: 0.875, // 16px -> 14px
  tiny: 0.8333, // 12px -> 10px
};

function getMultiplier(font: FontTypes): number {
  return mobileFontMultiplier[font] || 0.75;
}

export function themeFont(
  font: FontTypes
): ({ theme }: ThemeProps) => ThemeFont {
  return ({ theme }: ThemeProps): ThemeFont => {
    const f = theme.fonts[font];

    return {
      '@media (max-width: 640px)': {
        fontSize: `calc(${f?.fontSize} * ${getMultiplier(font)})`,
      },
      ...theme.fonts[font],
    };
  };
}
